module.exports = __webpack_public_path__ + "static/media/thumbnail.8a0f125d.jpg";